export const DOSIS_UNITS = [
  { value: "ml", text: "ML" },
  { value: "l", text: "L" },
  { value: "%", text: "%" },
  { value: "gr", text: "GR" },
  { value: "mgr", text: "MGR" },
  { value: "tableta", text: "TABLETA" },
  { value: "capsula", text: "CAPSULA" },
  { value: "gotas", text: "GOTAS" },
];

const DOSIS_UNIT_MAP = DOSIS_UNITS.reduce((acc, item) => {
  acc[item.text] = item;
  acc[item.value.toUpperCase()] = item;
  return acc;
}, {});

export const findDosisUnit = (unitText) => {
  if (!unitText) return null;
  return DOSIS_UNIT_MAP[String(unitText).trim().toUpperCase()] || null;
};

export const formatDosis = (numberValue, dosisUnit) => {
  const normalizedNumber = String(numberValue ?? '').trim();
  const unit = typeof dosisUnit === 'string'
    ? findDosisUnit(dosisUnit)
    : findDosisUnit(dosisUnit?.text || dosisUnit?.value);

  if (!normalizedNumber || !unit) return '';
  return `${normalizedNumber} ${unit.text}`;
};

export const parseDosis = (dosis) => {
  const normalizedDosis = String(dosis || '').trim().replace(/\s+/g, ' ');
  if (!normalizedDosis) {
    return { dosisNumber: '', dosisTipo: null };
  }

  const match = normalizedDosis.match(/^(\d+(?:[.,]\d+)?)\s+(.+)$/);
  if (!match) {
    return { dosisNumber: normalizedDosis, dosisTipo: null };
  }

  return {
    dosisNumber: match[1],
    dosisTipo: findDosisUnit(match[2]),
  };
};
